module.exports = __webpack_public_path__ + "img/orange_065.afc8e5e6.png";